export const links = [
    {
        "nombre" : "Transparencia",
        "link" : "/Transparencia",
        "submenu" : [
            {
                "subMenuNombre" : "48 Rubros",
                "subMenuUrl" : "/Transparencia/Rubros"
            },
            {
                "subMenuNombre" : "Rubros Anteriores",
                "subMenuUrl" : "/Transparencia/Rubros/RubrosHistoricos"
            },
            {
                "subMenuNombre" : "Articulo 70",
                "subMenuUrl" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/Semot/dir3/Historico/2025/a70_f01_gSEMOT.xlsx"
            }
           
        ]
    }
    ,
    {
            "nombre" : "Programa Sectorial",
            "submenu" : 
            [
                {
                    "subMenuNombre" : "Desarrollo de Movilidad y Transporte 2023-2028",
                    "subMenuUrl" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/Semot/2023/Documentos/Programa_Sectorial Movilidad y Transporte.pdf"
                }
                
            ]
            
    }
    ,
    {
        "nombre" : "Organismos Sectorizados",
        "submenu" : [
            // {
            //     "subMenuNombre" : "Tuzobús",
            //     "subMenuUrl" : "http://www.tuzobus.gob.mx/"
            // }
            // ,
            {
                "subMenuNombre" : "Sistema de Transporte Convencional de Hidalgo",
                "subMenuUrl" : "https://stch.hidalgo.gob.mx/?page_id=265"
            },
            {
                "subMenuNombre" : "Sistema Integrado de Transporte Masivo de Hidalgo",
                "subMenuUrl" : "https://sitmah.hidalgo.gob.mx/"
            }
                    ]
        
    }
    ,
    {
        "nombre" : "Ligas de Interés",
        "link" : "/Ligas"
    }
    ,
    {
        "nombre" : "Agenda",
        "link" : "/Agenda",
    }
    ,
   // {
   //     "nombre" : "Movilidad Responsable",
   //     "link" : "/Movilidad",
   // }
    
   
    

    // {
    //     "nombre" : "Servicios",
    //     "link" : "/Servicios",
    //     "submenu" : [
           
    //     ]
    // },
    // {
    //     "nombre" : "Domicilio",
    //     "link" : "/ServiciosGenerales",
    //     "submenu" : [
           
    //     ]
    // }
]